import { useContext } from "react";
import { GlobalContextType, GlobalContext } from "./GlobalContextProvider";

export function useCountryContext() {
  const { countries } = useContext<GlobalContextType>(GlobalContext);
  return countries;
}
